import { Action } from "redux";
import api from "../../api";
import { DomainRoot } from "../../typings/document-types";
import { AppThunk } from "..";
import { logError } from "../../errors";

export const UPDATE_DOMAIN = "UPDATE_DOMAIN";

export interface UpdateDomainAction extends Action
{
    type: typeof UPDATE_DOMAIN;
    domain: DomainRoot;
}

export const thunkUpdateDomain = (): AppThunk => async (dispatch) =>
{
    try
    {
        const response = await api.umbracoClient.getByRoute<DomainRoot>("/");

        if (response.statusCode === 200 && response.result)
        {
            const action: UpdateDomainAction = {
                type: UPDATE_DOMAIN,
                domain: response.result
            };
            dispatch(action);
        }
    }
    catch (error)
    {
        logError("Failed to find domain root", error);
    }
};

export type DomainActions = UpdateDomainAction;